<template>
    <div class="c-actions-list c-actions-list--vertical u-justify-content-center c-actions-cart" v-bind:class="{ first: isFirst }">
      <div class="c-actions-list__item u-full">
        <a href="/index.php?controller=order" class="c-btn c-btn--full c-btn--secondly c-btn--theme-6 u-text-uppercase">
          <span class="c-btn__wrap">
            <span class="c-btn__label">Do kasy</span>
            <span class="c-btn__ico">
              <span class="o-ico o-ico--arrow-right o-ico--s">
                <svg aria-hidden="true"><use xlink:href="#ico-right-open"></use></svg>
              </span>
            </span>
          </span>
        </a>
      </div>
      <div class="c-actions-list__item" v-if="!isLogged">
        <button type="button" class="c-link c-link--theme-4 u-text-underline" @click="openLogIn">
          <span class="c-link__wrap">
            <span class="c-link__ico">
              <span class="o-ico o-ico--person o-ico--s">
                <svg aria-hidden="true"><use xlink:href="#ico-person-fill"></use></svg>
              </span>
            </span>
            <span class="c-link__label">Zaloguj się aby zapisać koszyk</span>
          </span>
        </button>
      </div>
    </div>
</template>

<script>
export default {
  props: ['isLogged', 'linkOrder', 'isFirst'],
  methods: {
    openLogIn () {
      const eventClick = new Event('click')
      document.querySelector('.js-open-log-in').dispatchEvent(eventClick)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlockCart/BlockCartActions.vue